import { Chip, Grid } from "@mui/material";
import EditAction from "../components/edit-action/edit-action";
import DeleteAction from "../components/delete-action/delete-action";
import VerifyAccess from "@/common/components/verify-access/verify-access";
import { requestedMenuAll, requestedFeaturesAll } from "@/from-theme/routes/constants/menuAccess";
import { dateString } from "@/common/components/TableView/helpers/helpers";
const {zoneTabMasterKey} = requestedMenuAll;
const {updateKey, deleteKey} = requestedFeaturesAll;

export const columns = ({ onRowEdit, onRowDelete, deleteZoneMasterStatus,
  isUpdateDeleteAccess }) => ([...[
  {
    header: 's-no',
    accessorKey: 'notifySettingId',
    cell: (value) => {
      const notifySettingId = value.row.index + 1;
     return notifySettingId;
    }
  },
  {
    header: 'notification-settings-name',
    accessorKey: 'notificationSettingName'
  },
  {
    header: 'whatsapp-applicable',
    accessorKey: 'whatsappIsApplicable'
  },
  {
    header: 'email-applicable',
    accessorKey: 'emailIsApplicable'
  },
  {
    header: 'sms-applicable',
    accessorKey: 'smsIsApplicable'
  },
  {
    header: 'status',
    accessorKey: 'activeStatus',
    cell: (cell) => {
      switch (cell.getValue()) {
        case '0':
          return <Chip color="error" label="In-Active" size="small" variant="light" />;
        case '1':
          return <Chip color="success" label="Active" size="small" variant="light" />;

      }
    }
  },
  {
    header: 'created-at',
    hideColumn: true,
    accessorKey: 'createdAt',
    cell: ({ getValue }) => dateString(getValue()) 
  },
  {
    header: 'created-by',
    hideColumn: true,
    accessorKey: 'createdByName'
  },
  {
    header: 'updated-at',
    accessorKey: 'updatedAt',
    hideColumn: true,
    cell: ({ getValue }) => dateString(getValue()) 
  },
  {
    header: 'updated-by',
    hideColumn: true,
    accessorKey: 'updateByByName'
  },
], ...(isUpdateDeleteAccess ? [
  {
    header: 'action',
    id: "edit",
    cell: (props) => (
      <Grid container className="table-icon-actions-2">
        <VerifyAccess requestedMenu={zoneTabMasterKey} requestedFeature={updateKey}>
        <Grid item>
          <EditAction
            {...props}
            onRowEdit={onRowEdit}
          />
        </Grid>
        </VerifyAccess>
        <VerifyAccess requestedMenu={zoneTabMasterKey} requestedFeature={deleteKey}>
        <Grid item>
          <DeleteAction
            {...props}
            onRowDelete={onRowDelete} deleteZoneMasterStatus={deleteZoneMasterStatus}
          />
        </Grid>
        </VerifyAccess>
      </Grid>
    ),
    meta: {
      className: 'cell-center'
    }
  }
] : [])]);

export const reportFileName = "Zone Master";


